export enum ActivityStatusEnum {
  FOR_ALL_LEARNERS = 'FOR_ALL_LEARNERS',
  BY_RESIDENCE_ZONE = 'BY_RESIDENCE_ZONE',
  BY_CERTIFICATE_TYPE = 'BY_CERTIFICATE_TYPE',
  TO_DEFINE = 'TO_DEFINE',
}
